<script setup>
const props = defineProps({
    loteStore: Object,
    aceptarTerminosCondiciones: Object,
    preguntarAlert: Object
});

const emit = defineEmits(['terminosEnviados']);

async function confirmarTerminos() {
    await props.loteStore.aceptarTerminosCondiciones(props.loteStore.lote.subasta_id);
    await props.loteStore.obtenerAceptoTerminos(props.loteStore.lote.subasta_id);
    props.aceptarTerminosCondiciones.hide();
    emit('terminosEnviados');
}

function cerrarModal() {
    props.aceptarTerminosCondiciones.hide();
}   
</script>

<template>
    <!-- Modal de Bootstrap -->
    <div class="modal fade" id="aceptarTerminosCondiciones" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content text-center p-2 p-md-4 pt-5 position-relative">
                <div class="me-6 mx-6 mt-3">
                    <button type="button"
                        class="close position-absolute top-0 end-0 m-2 bg-light border-0 shadow-none rounded-circle d-flex align-items-center justify-content-center"
                        style="width: 40px; height: 40px;" @click="cerrarModal()">
                        <span class="fs-4">&times;</span>
                    </button>
                    <p class="fs-6"> Tenés que <strong>Aceptar Términos y Condiciones</strong> para poder ofertar.</p>
                    <div class="d-flex flex-column m-4 me-5 mx-5 gap-2">
                        <button class="btn btn-primary w-100" @click="confirmarTerminos">Aceptar</button>
                        <button class="btn btn-outline-primary" @click="cerrarModal()">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
